<template>
  <div class="animated fadeIn company">
    <vLoading v-if="vLoading" />
    <b-card
      v-if="$router.currentRoute.path.indexOf('/admin/accelerator') == 0"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <h2>پروفایل شتاب‌دهنده</h2>
      <hr />
      <b-tabs v-model="tabNumber" pills>
        <b-tab title="مشاهده" active style="padding: 0 !important">
          <b-card
            v-if="loaded"
            style="border: 0"
            class="company-view mt-0 mb-0"
          >
            <v-row class="">
              <v-col cols="12" sm="12" md="12" lg="6" xl="6">
                <v-card class="common-card company-card">
                  <v-row class="uni-header">
                    <v-col cols="12" class="d-flex flex-column flex-sm-row">
                      <div class="view-imageBox">
                        <img
                          :src="
                            acceleratorInfo.avatar
                              ? acceleratorInfo.avatar
                              : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTasF2J01pp5zzTcs1-GtFdrelxnu331FtNs6jNP6LRwfLdIpw0zZEB7iOOf5NoPeKb_8g&usqp=CAU'
                          "
                        />
                      </div>
                      <div class="description-box ps-5 pe-0">
                        <h5 class="mt-1 c-dark fs-xxlarge">
                          {{ acceleratorInfo.name }}
                        </h5>
                        <p
                          v-if="acceleratorInfo.description"
                          class="c-grey fs-medium text-justify"
                        >
                          {{
                            acceleratorInfo.description.length > 180
                              ? acceleratorInfo.description.slice(0, 180) +
                                "..."
                              : acceleratorInfo.description
                          }}
                        </p>
                        <p v-else class="c-grey fs-small">
                          توضیحی برای شتاب‌دهنده ثبت نشده است.
                        </p>
                      </div>
                    </v-col>
                  </v-row>
                  <div
                    v-if="acceleratorInfo.description.length > 220"
                    class="text-left pt-5"
                  >
                    <v-btn
                      class="seeMore-btn"
                      @click="openSeeMoreModal('description')"
                      text
                    >
                      <span class="c-primary">مشاهده بیشتر</span>
                    </v-btn>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="6" xl="6">
                <v-card class="common-card card-height">
                  <h5 class="mt-1 c-dark fs-xxlarge">
                    اطلاعات تماس شتاب‌دهنده
                  </h5>
                  <div class="pt-2 c-grey">
                    <v-icon class="ps-2">$Location</v-icon>
                    <span class="fs-medium">
                      نشانی شتاب‌دهنده:
                      {{
                        acceleratorInfo.state +
                        ", " +
                        acceleratorInfo.city +
                        (acceleratorInfo.city ? ", " : "")
                      }}
                      {{
                        acceleratorInfo.address ? acceleratorInfo.address : "--"
                      }}
                    </span>
                  </div>
                  <div class="pt-4 c-grey">
                    <v-icon class="ps-2">$Phone</v-icon>
                    <span class="fs-medium">
                      تلفن‌های تماس:
                      <span dir="ltr">{{
                        acceleratorInfo.tel ? acceleratorInfo.tel : "--"
                      }}</span>
                    </span>
                  </div>
                  <div class="pt-4 c-grey">
                    <v-icon class="ps-2">$Email</v-icon>
                    <span class="fs-medium">
                      ایمیل:
                      {{ acceleratorInfo.email ? acceleratorInfo.email : "--" }}
                    </span>
                  </div>
                  <div class="pt-4 c-grey">
                    <v-icon class="ps-2">$Url</v-icon>
                    <span class="fs-medium" v-if="acceleratorInfo.website">
                      آدرس‌‌ تارنما:
                      <a :href="checkWebsite()" target="_blank">{{
                        acceleratorInfo.website
                      }}</a>
                    </span>
                    <span class="fs-medium" v-else> آدرس‌‌ تارنما: -- </span>
                  </div>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="6" xl="6"
                ><v-card class="common-card company-stretch card-height">
                  <v-row>
                    <v-col>
                      <h5 class="mb-4 fs-xxlarge c-dark">
                        موضوع فعالیت زیست فناوری
                      </h5>
                    </v-col>
                  </v-row>
                  <div v-if="!acceleratorInfo.catId" class="text-center mt-5">
                    <hr />
                    <span class="fs-small c-grey"
                      >موضوعی به ثبت نرسیده است.</span
                    >
                    <hr />
                  </div>
                  <div v-else>
                    <div>
                      <ul class="mb-3 c-grey">
                        <li>
                          <v-icon class="c-grey">mdi-circle-medium</v-icon>
                          <span class="fs-medium">
                            {{ acceleratorInfo.catName }}
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </v-card>
              </v-col>

              <v-col
                v-if="acceleratorInfo.products"
                cols="12"
                sm="12"
                md="12"
                lg="6"
                xl="6"
              >
                <v-card class="common-card company-stretch card-height">
                  <v-row>
                    <v-col>
                      <h5 class="mb-4 fs-xxlarge c-dark">محصولات شتاب‌دهنده</h5>
                    </v-col>
                    <v-col class="text-left">
                      <h6 class="fs-large">
                        {{
                          acceleratorInfo.products.length
                            ? acceleratorInfo.products.length + " مورد "
                            : ""
                        }}
                      </h6>
                    </v-col>
                  </v-row>
                  <div v-if="acceleratorInfo.products">
                    <div v-if="acceleratorInfo.products.length">
                      <div v-if="acceleratorInfo.products.length > 3">
                        <div
                          v-for="(
                            product, index
                          ) in acceleratorInfo.products.slice(0, 3)"
                          :key="index"
                          class="mb-3 ps-2"
                        >
                          <li class="fs-medium c-grey">
                            <v-icon class="c-grey">mdi-circle-medium</v-icon>
                            {{
                              product.title.length > 60
                                ? product.title.slice(0, 60) + "..."
                                : product.title
                            }}
                          </li>
                        </div>
                        <div class="text-left pt-5">
                          <v-btn
                            class="seeMore-btn"
                            @click="openSeeMoreModal('product')"
                            text
                          >
                            <span class="c-primary">مشاهده بیشتر</span>
                          </v-btn>
                        </div>
                      </div>
                      <div v-else>
                        <div
                          v-for="(product, index) in acceleratorInfo.products"
                          :key="index"
                          class="mb-3 ps-2"
                        >
                          <li class="fs-medium c-grey">
                            <v-icon class="c-grey">mdi-circle-medium</v-icon>
                            {{
                              product.title.length > 60
                                ? product.title.slice(0, 60) + "..."
                                : product.title
                            }}
                          </li>
                        </div>
                        <div class="text-left pt-5">
                          <v-btn
                            class="seeMore-btn"
                            @click="openSeeMoreModal('product')"
                            v-if="showProductMoreBtn"
                            text
                          >
                            <span class="c-primary">مشاهده بیشتر</span>
                          </v-btn>
                        </div>
                      </div>
                    </div>
                    <div v-else class="c-grey fs-small text-center mt-5">
                      <hr />
                      <span class="fs-small c-grey"
                        >محصولی به ثبت نرسیده است.</span
                      >
                      <hr />
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-if="type != 'mobile'">
              <v-col>
                <v-card class="common-card w-100">
                  <v-card-title class="pa-0 pb-4">
                    <h5 class="fs-xxlarge">گالری تصاویر</h5>
                  </v-card-title>
                  <div
                    v-if="!acceleratorInfo.gallery.length"
                    class="pa-5 text-center"
                  >
                    <hr />
                    <span class="fs-small c-grey mx-auto"
                      >تصویری برای این شتاب‌دهنده به ثبت نرسیده است.</span
                    >
                    <hr />
                  </div>
                  <v-row class="d-flex flex-column" v-else>
                    <v-row>
                      <v-col
                        class="text-center img-col d-flex"
                        sm="4"
                        md="4"
                        lg="2"
                        xl="2"
                        v-for="(img, index) in acceleratorInfo.gallery.slice(
                          0,
                          6
                        )"
                        :key="index"
                      >
                        <img :src="img.url" class="gallery-img mb-2" />
                        <span class="fs-medium c-grey">{{
                          img.title.length > 15
                            ? img.title.slice(0, 15) + "..."
                            : img.title
                        }}</span>
                      </v-col>
                    </v-row>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col>
                <v-card class="common-card w-100">
                  <v-card-title>
                    <h5>گالری تصاویر</h5>
                  </v-card-title>

                  <v-row class="main-div" s>
                    <v-carousel
                      :show-arrows="acceleratorInfo.gallery.length > 1"
                      v-model="model"
                      hide-delimiters
                    >
                      <v-carousel-item
                        cycle
                        v-for="(img, index) in acceleratorInfo.gallery"
                        :key="index"
                        :src="img.url"
                        reverse-transition="fade-transition"
                        transition="fade-transition"
                        class="slider-img"
                      >
                      </v-carousel-item>
                    </v-carousel>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </b-card>
        </b-tab>
        <b-tab title="اطلاعات شتاب‌دهنده">
          <b-card style="border: 0" class="mt-0 mb-0">
            <b-row class="mb-lg-3 mb-0">
              <b-col cols="12" sm="12" md="3" lg="3">
                <div
                  tabindex="0"
                  class="edit-imageBox"
                  @click="
                    uploading = false;
                    addLogoImage = true;
                  "
                >
                  <img
                    style="cursor: pointer"
                    :src="
                      editInfo.avatar
                        ? editInfo.avatar
                        : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTasF2J01pp5zzTcs1-GtFdrelxnu331FtNs6jNP6LRwfLdIpw0zZEB7iOOf5NoPeKb_8g&usqp=CAU'
                    "
                  />
                </div>
              </b-col>
              <b-col cols="12" sm="12" md="9" lg="9" class="mt-lg-2">
                <b-row class="mb-2">
                  <b-col>
                    <div class="disabled-fields grey lighten-3">
                      نام کاربری: {{ editInfo.username }}
                    </div>
                  </b-col>
                </b-row>
                <b-form-group
                  label="نام شتاب‌دهنده"
                  :class="editInfo.name ? 'done' : 'required'"
                >
                  <b-form-input
                    trim
                    v-model="editInfo.name"
                    type="text"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  label="شماره همراه"
                  :class="editInfo.mobile ? 'done' : 'required'"
                >
                  <b-form-input
                    trim
                    v-model="editInfo.mobile"
                    :no-wheel="true"
                    type="number"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-form-group label="توضیحات">
              <b-form-textarea
                id="textarea"
                v-model="editInfo.description"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>
            <b-row>
              <b-col md="6" cols="12">
                <b-form-group label="استان">
                  <v-autocomplete
                    v-model="editInfo.stateId"
                    :items="iran"
                    @change="editInfo.cityId = ''"
                    item-value="id"
                    item-text="name"
                    dense
                    outlined
                    class="dropdown-style"
                    hide-details
                  ></v-autocomplete>
                </b-form-group>
              </b-col>
              <b-col md="6" cols="12">
                <b-form-group label="شهر">
                  <v-autocomplete
                    v-model="editInfo.cityId"
                    :items="
                      iran
                        .filter((x) => x.id == editInfo.stateId)
                        .map((y) => y.cities)[0]
                    "
                    item-value="id"
                    item-text="name"
                    dense
                    outlined
                    class="dropdown-style"
                    hide-details
                  ></v-autocomplete>
                </b-form-group>
              </b-col>
            </b-row>

            <b-form-group label="آدرس">
              <b-form-input
                trim
                v-model="editInfo.address"
                type="text"
              ></b-form-input>
            </b-form-group>
            <b-form-group label="تلفن‌های تماس">
              <b-form-input
                trim
                v-model="editInfo.tel"
                :no-wheel="true"
              ></b-form-input>
            </b-form-group>
            <b-form-group label="ایمیل">
              <b-form-input
                trim
                v-model="editInfo.email"
                type="email"
                :state="validateEmail(editInfo.email) ? null : false"
                aria-describedby="email"
              ></b-form-input>
              <b-form-invalid-feedback id="email"
                >پست الکترونیک صحیح نیست</b-form-invalid-feedback
              >
            </b-form-group>
            <b-form-group label="آدرس تارنما">
              <b-form-input
                trim
                v-model="editInfo.website"
                :state="checkUrl(editInfo.website) ? null : false"
                type="url"
              ></b-form-input>
              <b-form-invalid-feedback id="url"
                >آدرس تارنما صحیح نیست</b-form-invalid-feedback
              >
            </b-form-group>
            <b-form-group label="مدیر عامل">
              <b-form-input
                trim
                v-model="editInfo.ceoName"
                type="text"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              label="شماره ثبت"
              :class="editInfo.registrationNumber ? 'done' : 'required'"
            >
              <b-form-input
                trim
                v-model="editInfo.registrationNumber"
                type="number"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              label="شناسه ملی"
              :class="editInfo.nationalId ? 'done' : 'required'"
            >
              <b-form-input
                trim
                v-model="editInfo.nationalId"
                type="number"
              ></b-form-input>
            </b-form-group>
            <b-form-group label="کد اقتصادی">
              <b-form-input
                trim
                v-model="editInfo.economicCode"
                type="number"
              ></b-form-input>
            </b-form-group>
            <div class="d-flex flex-row my-5">
              <b-form-checkbox v-model="editInfo.isTrusted"></b-form-checkbox>
              <span class="ps-2"> شتاب‌دهنده معتمد می‌باشد. </span>
            </div>
            <b-form-group label="موضوع فعالیت زیست فناوری">
              <v-autocomplete
                v-model="editInfo.catId"
                :items="categories"
                item-value="code"
                item-text="label"
                dense
                outlined
                class="dropdown-style"
                hide-details
              ></v-autocomplete>
            </b-form-group>
            <b-form-group label="محصولات">
              <b-row class="pb-5">
                <b-col>
                  <b-form-input
                    trim
                    v-model="newProduct"
                    :no-wheel="true"
                    placeholder="محصول"
                    type="text"
                  ></b-form-input>
                </b-col>
                <b-col>
                  <b-button
                    variant="success"
                    @click="addProduct()"
                    style="float: right"
                    :disabled="!newProduct"
                    ><strong>افزودن محصول جدید +</strong></b-button
                  >
                </b-col>
              </b-row>

              <b-table
                responsive
                show-empty
                head-variant="dark"
                :fields="productFields"
                :items="editInfo.products"
                :current-page="productCurrentPage"
                :per-page="productPerPage"
                empty-text="هنوز محصولی ثبت نشده است"
                empty-filtered-text="نتیجه یافت نشد"
                striped
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{
                      data.index + 1 + productPerPage * (productCurrentPage - 1)
                    }}
                  </div>
                </template>
                <template v-slot:cell(operation)="data">
                  <div
                    style="
                      text-align: center;
                      vertical-align: middle;
                      width: 150px;
                      margin: auto;
                    "
                  >
                    <b-button
                      variant="danger"
                      @click="editInfo.products.splice(data.index, 1)"
                      ><v-icon color="white">mdi-close-circle</v-icon></b-button
                    >
                  </div>
                </template>
                <div slot="table-busy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </b-table>
              <b-pagination
                v-model="productCurrentPage"
                :total-rows="productTotalRows"
                :per-page="productPerPage"
                first-text="ابتدا"
                prev-text="قبلی"
                next-text="بعدی"
                last-text="آخر"
                align="center"
                size="sm"
                class="my-0"
              ></b-pagination>
            </b-form-group>

            <div class="mt-6">
              <v-btn
                class="green-btn"
                :disabled="
                  isBusy ||
                  !computedUsername ||
                  !editInfo.name ||
                  !validateEmail(editInfo.email) ||
                  !checkUrl(editInfo.website)
                "
                @click="submit()"
              >
                <v-icon class="me-1">mdi-check</v-icon>
                ثبت تغییرات</v-btn
              >
            </div>
          </b-card>
        </b-tab>
        <b-tab title="محورهای زیست فناوری">
          <b-button
            variant="success"
            @click="openAdd3()"
            style="float: right"
            class="my-2"
            ><strong>افزودن محور جدید +</strong></b-button
          >
          <b-modal no-close-on-backdrop id="add3" ref="add3" size="lg">
            <h4>افزودن محور جدید</h4>
            <br />
            <h6>محور مورد نظر خود را انتخاب کنید:</h6>
            <v-autocomplete
              :items="mehvars"
              v-model="newMehvar"
              item-value="id"
              item-text="text"
              outlined
              dense
              class="mt-3"
            >
            </v-autocomplete>
            <template v-slot:modal-footer>
              <!-- NOTE (b-addMehvar3) previous -->
              <b-button
                :disabled="!newMehvar"
                variant="success"
                @click="addMehvar()"
                >افزودن</b-button
              >
            </template>
          </b-modal>
          <b-table
            responsive
            show-empty
            head-variant="dark"
            :fields="mehvarFields"
            :items="acceleratorInfo.mehvars"
            empty-text="رکوردی برای نمایش وجود ندارد"
            empty-filtered-text="نتیجه یافت نشد"
            striped
            :busy="mehvarBusy"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(operation)="data">
              <div style="text-align: center; vertical-align: middle">
                <v-btn
                  class="red white--text"
                  elevation="0"
                  @click="openRemoveMehvarDialog(data.item)"
                >
                  <v-icon left class="mb-1">mdi-delete-outline</v-icon>
                  <span>حذف</span>
                </v-btn>
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + 1 }}
              </div>
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
        </b-tab>
        <v-dialog v-model="removeMehvarDialog" max-width="600">
          <v-card class="delete-modalCard">
            <v-container class="pa-5">
              <div class="text-left pointer">
                <span @click="removeMehvarDialog = false">
                  <v-icon>mdi-close</v-icon>
                </span>
              </div>
              <div class="fs-medium mt-2">
                آیا از حذف محور
                <b> "{{ selectedMehvar.name }}" </b>
                اطمینان دارید؟
              </div>
              <div class="mt-9 text-end">
                <v-btn
                  @click="removeMehvar()"
                  elevation="0"
                  class="bc-primary c-light mx-2"
                  >تایید</v-btn
                >
                <v-btn
                  @click="removeMehvarDialog = false"
                  elevation="0"
                  class="b-primary bc-white c-primary"
                  >لغو</v-btn
                >
              </div>
            </v-container>
          </v-card>
        </v-dialog>
        <b-tab title="تصاویر شتاب‌دهنده">
          <b-card style="border: 0" class="mt-0 mb-0">
            <div>
              <v-btn
                elevation="0"
                width="200"
                height="48"
                class="b-primary bc-white c-primary"
                @click="openAddImageModal()"
                ><v-icon>mdi-plus</v-icon> افزودن تصویر
              </v-btn>
            </div>

            <div>
              <v-row v-if="loaded" class="mt-0">
                <v-col v-if="!acceleratorInfo.gallery.length">
                  <div class="text-center mt-8">
                    <hr />
                    تصویری ثبت نشده است.
                    <hr />
                  </div>
                </v-col>
                <v-col
                  md="4"
                  sm="6"
                  cols="12"
                  v-else
                  v-for="(item, index) in acceleratorInfo.gallery"
                  :key="index"
                >
                  <div class="px-4">
                    <div class="gallery-imageBox">
                      <v-img :src="item.url"></v-img>
                      <div class="image-title d-flex flex-row">
                        <div>
                          {{
                            item.title.length > 25
                              ? item.title.slice(0, 25) + "..."
                              : item.title
                          }}
                        </div>
                        <v-spacer></v-spacer>
                        <div @click="openEditDialog(item)" class="pe-3">
                          <v-icon
                            class="img-icons"
                            style="transform: translateY(-1px)"
                            >$Edit</v-icon
                          >
                        </div>
                        <div @click="openDeleteDialog(item)">
                          <v-icon class="img-icons">$Trash</v-icon>
                        </div>
                      </div>
                      <div class="hover-box" @click="showBig(item)">
                        <div>
                          <v-icon>$zoomIcon</v-icon>
                          <p class="fs-large mt-2 mb-0">مشاهده</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>
            <v-dialog v-model="addLogoImage" width="450">
              <v-card class="modal-card">
                <v-container class="p-4">
                  <v-row class="mb-1">
                    <v-col class="text-right">
                      <h5 class="mt-1 c-dark fs-xlarge">ویرایش لوگو</h5>
                    </v-col>
                    <v-col cols="2" class="text-left">
                      <span @click="addLogoImage = false">
                        <v-icon class="pointer">mdi-close</v-icon>
                      </span>
                    </v-col>
                  </v-row>
                  <div v-if="!uploading">
                    <div
                      class="upload-box"
                      @dragover="dragover"
                      @dragleave="dragleave"
                      @drop="drop"
                    >
                      <p class="c-grey fs-large mb-2">
                        فایل مورد نظر را به این قسمت بکشید
                      </p>

                      <p class="c-grey fs-large mb-2">یا</p>
                      <v-btn
                        @click="$refs.upload.$refs.input.click()"
                        class="c-primary b-primary bc-white"
                        elevation="0"
                        height="42"
                        >یافتن فایل</v-btn
                      >
                    </div>
                  </div>
                  <div v-else>
                    <div class="d-flex flex-row w-100">
                      <div class="file-icon">
                        <v-icon large>$File</v-icon>
                      </div>
                      <div class="w-100 px-3">
                        <p class="mb-0">در حال بارگذاری تصویر...</p>
                        <v-progress-linear
                          class="mt-1"
                          outlined
                          height="4"
                          :value="myFile.uploadPercentage"
                          color="#068D9D"
                        >
                        </v-progress-linear>
                      </div>
                      <div class="c-primary pt-4">
                        {{ myFile.uploadPercentage }}%
                      </div>
                    </div>
                  </div>
                </v-container>
              </v-card>
            </v-dialog>
            <v-file-input
              @change="myUpload(file)"
              v-model="file"
              ref="upload"
              outlined
              dense
              v-show="false"
            ></v-file-input>
            <v-dialog v-model="showImage" max-width="590">
              <v-card class="show-modalCard">
                <v-container class="text-center">
                  <div>
                    <img :src="selected.url" />
                  </div>
                  <div class="px-1 mt-4 fs-medium text-right">
                    {{ selected.title }}
                  </div>
                </v-container>
              </v-card>
            </v-dialog>
            <v-dialog v-model="deleteImage" max-width="590">
              <v-card class="delete-modalCard">
                <v-container class="text-center pa-5">
                  <div class="text-left pointer">
                    <span @click="deleteImage = false">
                      <v-icon>mdi-close</v-icon>
                    </span>
                  </div>
                  <div class="mb-5">
                    <img :src="selected.url" />
                  </div>
                  <span class="fs-medium">آیا از حذف تصویر اطمینان دارید؟</span>
                  <div class="mt-9">
                    <v-btn
                      @click="deleteImage = false"
                      elevation="0"
                      class="b-primary bc-white c-primary mx-2"
                      >لغو</v-btn
                    >
                    <v-btn
                      @click="deleteImg()"
                      elevation="0"
                      class="bc-primary c-light mx-2"
                      :disabled="busy"
                      >تایید</v-btn
                    >
                  </div>
                </v-container>
              </v-card>
            </v-dialog>
            <v-dialog v-model="editImage" max-width="590">
              <v-card class="modal-card">
                <v-container class="text-center pa-5">
                  <v-row class="mb-2">
                    <v-col class="text-right c-dark fs-xxlarge">
                      ویرایش عنوان تصویر
                    </v-col>
                    <v-col class="text-left" cols="2">
                      <span class="pointer" @click="editImage = false">
                        <v-icon>mdi-close</v-icon>
                      </span>
                    </v-col>
                  </v-row>
                  <div class="textField-box2 mt-4">
                    <v-text-field
                      rounded
                      outlined
                      v-model="selected.title"
                    ></v-text-field>
                  </div>
                  <div class="mt-5">
                    <v-btn
                      @click="editImage = false"
                      elevation="0"
                      class="b-primary bc-white c-primary mx-2"
                      >لغو</v-btn
                    >
                    <v-btn
                      @click="editImg()"
                      elevation="0"
                      class="bc-primary c-light mx-2"
                      :disabled="busy"
                      >تایید</v-btn
                    >
                  </div>
                </v-container>
              </v-card>
            </v-dialog>
            <v-dialog v-model="addImage" width="450">
              <v-card class="modal-card">
                <v-container class="p-4">
                  <v-row class="mb-1">
                    <v-col class="text-right">
                      <h5 class="mt-1 c-dark fs-xlarge">افزودن تصویر</h5>
                    </v-col>
                    <v-col cols="2" class="text-left">
                      <span @click="addImage = false">
                        <v-icon class="pointer">mdi-close</v-icon>
                      </span>
                    </v-col>
                  </v-row>
                  <div v-if="!uploading">
                    <div class="textField-box2 pt-4 d-flex flex-row">
                      <span class="pe-4 ps-0 pt-3 c-dark fs-medium"
                        >عنوان تصویر:
                      </span>
                      <div>
                        <v-text-field
                          placeholder="عنوان"
                          rounded
                          outlined
                          class="w-100"
                          v-model="title"
                        ></v-text-field>
                      </div>
                    </div>
                    <hr class="mb-7 mt-0" />
                    <div
                      class="upload-box"
                      :class="!title ? 'disabled' : ''"
                      @dragover="dragover"
                      @dragleave="dragleave"
                      @drop="drop"
                    >
                      <p class="c-grey fs-large mb-1">
                        {{
                          title
                            ? "فایل مورد نظر را به این قسمت بکشید"
                            : "ابتدا عنوان تصویر را وارد نمایید."
                        }}
                      </p>
                      <p v-if="title" class="c-grey fs-large mb-2">یا</p>
                      <v-btn
                        v-if="title"
                        @click="$refs.uploadImage.$refs.input.click()"
                        class="c-primary b-primary bc-white"
                        elevation="0"
                        height="42"
                        >یافتن فایل</v-btn
                      >
                    </div>
                  </div>
                  <div v-else>
                    <div class="d-flex flex-row w-100">
                      <div class="file-icon">
                        <v-icon large>$File</v-icon>
                      </div>
                      <div class="w-100 px-3">
                        <p class="mb-0">در حال بارگذاری تصویر...</p>
                        <v-progress-linear
                          class="mt-1"
                          outlined
                          height="4"
                          :value="myFile.uploadPercentage"
                          color="#068D9D"
                        >
                        </v-progress-linear>
                      </div>
                      <div class="c-primary pt-4">
                        {{ myFile.uploadPercentage }}%
                      </div>
                    </div>
                  </div>
                </v-container>
              </v-card>
            </v-dialog>
          </b-card>
        </b-tab>
        <b-tab title="حمایت‌های شتاب‌دهنده">
          <b-tabs vertical pills>
            <b-tab title="طرح‌ها"
              ><b-input-group size="md" class="mb-3">
                <b-form-input
                  trim
                  v-model="projectFilter"
                  type="search"
                  id="filterInput"
                  placeholder="جستجو"
                ></b-form-input>
                <b-input-group-append>
                  <!-- NOTE (b-delete) to delete the text of the search bar -->
                  <b-button
                    :disabled="!projectFilter"
                    @click="projectFilter = ''"
                    variant="danger"
                    >حذف</b-button
                  >
                </b-input-group-append>
              </b-input-group>

              <!-- NOTE (t-acceleratorProposals) to show the accelerator proposals list -->
              <b-table
                responsive
                show-empty
                head-variant="dark"
                :fields="planFields"
                :items="requests.project"
                empty-text="رکوردی برای نمایش وجود ندارد"
                empty-filtered-text="نتیجه یافت نشد"
                striped
                :busy="requestBusy"
                :filter="projectFilter"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                <template v-slot:cell(operation)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        width: 150px;
                        margin: auto;
                      "
                    >
                      <!-- NOTE (<a>) to show the proposal details -->
                      <a
                        :href="'/admin/proposal/' + data.item.id"
                        target="_blank"
                        class="btn btn-primary text-light"
                        style="width: 100%"
                        >جزییات</a
                      >
                    </div>
                  </div>
                </template>
                <div slot="table-busy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div> </b-table
            ></b-tab>
            <b-tab title="رساله‌های‌ دکتری"
              ><b-input-group size="md" class="mb-3">
                <b-form-input
                  trim
                  v-model="phdFilter"
                  type="search"
                  id="filterInput"
                  placeholder="جستجو"
                ></b-form-input>
                <b-input-group-append>
                  <!-- NOTE (b-delete) to delete the text of the search bar -->
                  <b-button
                    :disabled="!phdFilter"
                    @click="phdFilter = ''"
                    variant="danger"
                    >حذف</b-button
                  >
                </b-input-group-append>
              </b-input-group>

              <!-- NOTE (t-acceleratorProposals) to show the accelerator proposals list -->
              <b-table
                responsive
                show-empty
                head-variant="dark"
                :fields="planFields"
                :items="requests.phd"
                empty-text="رکوردی برای نمایش وجود ندارد"
                empty-filtered-text="نتیجه یافت نشد"
                striped
                :busy="requestBusy"
                :filter="phdFilter"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                <template v-slot:cell(operation)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        width: 150px;
                        margin: auto;
                      "
                    >
                      <!-- NOTE (<a>) to show the proposal details -->
                      <a
                        :href="'/admin/phdProposal/' + data.item.id"
                        target="_blank"
                        class="btn btn-primary text-light"
                        style="width: 100%"
                        >جزییات</a
                      >
                    </div>
                  </div>
                </template>
                <div slot="table-busy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div> </b-table
            ></b-tab>
            <b-tab title="پایان‌نامه‌های ارشد"
              ><b-input-group size="md" class="mb-3">
                <b-form-input
                  trim
                  v-model="masterFilter"
                  type="search"
                  id="filterInput"
                  placeholder="جستجو"
                ></b-form-input>
                <b-input-group-append>
                  <!-- NOTE (b-delete) to delete the text of the search bar -->
                  <b-button
                    :disabled="!masterFilter"
                    @click="masterFilter = ''"
                    variant="danger"
                    >حذف</b-button
                  >
                </b-input-group-append>
              </b-input-group>

              <!-- NOTE (t-acceleratorProposals) to show the accelerator proposals list -->
              <b-table
                responsive
                show-empty
                head-variant="dark"
                :fields="planFields"
                :items="requests.master"
                empty-text="رکوردی برای نمایش وجود ندارد"
                empty-filtered-text="نتیجه یافت نشد"
                striped
                :busy="requestBusy"
                :filter="masterFilter"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                <template v-slot:cell(operation)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        width: 150px;
                        margin: auto;
                      "
                    >
                      <!-- NOTE (<a>) to show the proposal details -->
                      <a
                        :href="'/admin/masterProposal/' + data.item.id"
                        target="_blank"
                        class="btn btn-primary text-light"
                        style="width: 100%"
                        >جزییات</a
                      >
                    </div>
                  </div>
                </template>
                <div slot="table-busy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div> </b-table
            ></b-tab>
            <b-tab title="فرصت‌های مطالعاتی"
              ><b-input-group size="md" class="mb-3">
                <b-form-input
                  trim
                  v-model="opportuneFilter"
                  type="search"
                  id="filterInput"
                  placeholder="جستجو"
                ></b-form-input>
                <b-input-group-append>
                  <!-- NOTE (b-delete) to delete the text of the search bar -->
                  <b-button
                    :disabled="!opportuneFilter"
                    @click="opportuneFilter = ''"
                    variant="danger"
                    >حذف</b-button
                  >
                </b-input-group-append>
              </b-input-group>

              <!-- NOTE (t-acceleratorProposals) to show the accelerator proposals list -->
              <b-table
                responsive
                show-empty
                head-variant="dark"
                :fields="planFields"
                :items="requests.opportune"
                empty-text="رکوردی برای نمایش وجود ندارد"
                empty-filtered-text="نتیجه یافت نشد"
                striped
                :busy="requestBusy"
                :filter="opportuneFilter"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                <template v-slot:cell(operation)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        width: 150px;
                        margin: auto;
                      "
                    >
                      <!-- NOTE (<a>) to show the proposal details -->
                      <a
                        :href="'/admin/opportunity/' + data.item.id"
                        target="_blank"
                        class="btn btn-primary text-light"
                        style="width: 100%"
                        >جزییات</a
                      >
                    </div>
                  </div>
                </template>
                <div slot="table-busy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div> </b-table
            ></b-tab>
            <b-tab title="پسا دکتری"
              ><b-input-group size="md" class="mb-3">
                <b-form-input
                  trim
                  v-model="postDocFilter"
                  type="search"
                  id="filterInput"
                  placeholder="جستجو"
                ></b-form-input>
                <b-input-group-append>
                  <!-- NOTE (b-delete) to delete the text of the search bar -->
                  <b-button
                    :disabled="!postDocFilter"
                    @click="postDocFilter = ''"
                    variant="danger"
                    >حذف</b-button
                  >
                </b-input-group-append>
              </b-input-group>

              <!-- NOTE (t-acceleratorProposals) to show the accelerator proposals list -->
              <b-table
                responsive
                show-empty
                head-variant="dark"
                :fields="planFields"
                :items="requests.postDoc"
                empty-text="رکوردی برای نمایش وجود ندارد"
                empty-filtered-text="نتیجه یافت نشد"
                striped
                :busy="requestBusy"
                :filter="postDocFilter"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                <template v-slot:cell(operation)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        width: 150px;
                        margin: auto;
                      "
                    >
                      <!-- NOTE (<a>) to show the proposal details -->
                      <a
                        :href="'/admin/postDoc/' + data.item.id"
                        target="_blank"
                        class="btn btn-primary text-light"
                        style="width: 100%"
                        >جزییات</a
                      >
                    </div>
                  </div>
                </template>
                <div slot="table-busy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div> </b-table
            ></b-tab>
          </b-tabs>
        </b-tab>

        <b-tab title="تغییر رمز عبور">
          <b-form-group label="رمز عبور">
            <b-form-input
              trim
              v-model="acceleratorPassword"
              type="password"
              @input="passStrength"
              autocomplete="new-password"
            ></b-form-input>
          </b-form-group>
          <!--============== checking password =========== -->
          <b-row class="w-50">
            <b-col>
              <!-- NOTE check if the pass has more than 8 charector -->
              <p
                class="pass"
                :class="{ 'pass--passed': acceleratorPassword.length > 7 }"
              >
                <i
                  class="frmIcon fa"
                  :class="
                    acceleratorPassword.length > 7 ? 'fa-check' : 'fa-times'
                  "
                ></i>
                حداقل ۸ نویسه
              </p>
            </b-col>
            <b-col>
              <!-- NOTE check if the pass has uppercase -->
              <p class="pass" :class="{ 'pass--passed': has_uppercase }">
                <i
                  class="frmIcon fa"
                  :class="has_uppercase ? 'fa-check' : 'fa-times'"
                ></i>
                دارای حروف بزرگ باشد
              </p>
            </b-col>
          </b-row>
          <b-row class="w-50">
            <b-col>
              <!-- NOTE check if the pass has lowercase -->
              <p class="pass" :class="{ 'pass--passed': has_lowercase }">
                <i
                  class="frmIcon fa"
                  :class="has_lowercase ? 'fa-check' : 'fa-times'"
                ></i>
                دارای حروف کوچک باشد
              </p>
            </b-col>
            <b-col>
              <!-- NOTE check if the pass has number -->
              <p class="pass" :class="{ 'pass--passed': has_number }">
                <i
                  class="frmIcon fa"
                  :class="has_number ? 'fa-check' : 'fa-times'"
                ></i>
                دارای عدد باشد
              </p>
            </b-col>
          </b-row>

          <!--============== checking password =========== -->
          <b-form-group label="تکرار رمز عبور">
            <b-form-input
              trim
              v-model="acceleratorRepeatPassword"
              type="password"
              aria-describedby="repeat-password"
              :state="checkPassword"
            ></b-form-input>
            <b-form-invalid-feedback id="repeat-password"
              >رمز عبور با تکرار آن همخوانی ندارد</b-form-invalid-feedback
            >
          </b-form-group>
          <b-input-group size="md" class="mb-3">
            <!-- NOTE (b-changePass) to change the password -->
            <v-btn
              class="blue-btn"
              @click="changePassword"
              :disabled="isBusy || checkPassword == false"
              >تغییر رمز</v-btn
            >
          </b-input-group>
        </b-tab>
      </b-tabs>
    </b-card>
    <v-dialog v-model="seeMoreModal" width="600">
      <v-card v-if="seeMoreType == 'description'" class="modal-card">
        <v-container class="p-4">
          <v-row class="mb-1">
            <v-col class="text-right">
              <h5 class="mt-1 c-dark fs-xxlarge">{{ acceleratorInfo.name }}</h5>
            </v-col>
            <v-col class="text-left">
              <span @click="seeMoreModal = false">
                <v-icon class="pointer">$Close</v-icon>
              </span>
            </v-col>
          </v-row>

          <p class="c-grey fs-medium text-justify" style="line-height: 30px">
            {{ acceleratorInfo.description }}
          </p>
        </v-container>
      </v-card>
      <v-card v-if="seeMoreType == 'category'" class="modal-card">
        <v-container class="p-4">
          <v-row class="mb-1">
            <v-col class="text-right">
              <h5 class="mt-1 c-dark fs-xxlarge">موضوع فعالیت زیست فناوری</h5>
            </v-col>
            <v-col class="text-left">
              <span @click="seeMoreModal = false">
                <v-icon class="pointer">$Close</v-icon>
              </span>
            </v-col>
          </v-row>

          <div class="categories-box">
            <div class="mb-5">
              <span class="c-grey fs-medium">
                <v-icon class="pt-1 c-grey">mdi-circle-medium</v-icon>
                {{ " " + acceleratorInfo.catName }}
              </span>
            </div>
          </div>
        </v-container>
      </v-card>
      <v-card v-if="seeMoreType == 'product'" class="modal-card">
        <v-container class="p-4">
          <v-row class="mb-1">
            <v-col class="text-right">
              <h5 class="mt-1 c-dark fs-xxlarge">محصولات</h5>
            </v-col>
            <v-col class="text-left">
              <span @click="seeMoreModal = false">
                <v-icon class="pointer">$Close</v-icon>
              </span>
            </v-col>
          </v-row>

          <div class="products-box">
            <div
              v-for="(product, index) in acceleratorInfo.products"
              :key="index"
              class="mb-5"
            >
              <span class="c-grey fs-medium">
                <v-icon class="pt-1 c-grey">mdi-circle-medium</v-icon>
                {{ " " + product.title }}
              </span>
            </div>
          </div>
        </v-container>
      </v-card>
    </v-dialog>

    <v-file-input
      @change="myUpload(file)"
      v-model="file"
      ref="upload"
      outlined
      dense
      v-show="false"
    ></v-file-input>
    <v-file-input
      @change="uploadImage(file)"
      v-model="file"
      ref="uploadImage"
      outlined
      dense
      v-show="false"
    ></v-file-input>
  </div>
</template>
<script>
import Select2 from "v-select2-component";
import { MultiSelect } from "vue-search-select";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import validator from "validator";
import isURL from "validator/lib/isURL";
import md5 from "js-md5";
export default {
  components: {
    Select2,
    datePicker: VuePersianDatetimePicker,
    MultiSelect,
    isURL,
    validator,
  },
  data() {
    return {
      categories: [],
      acceleratorInfo: {},
      editInfo: {},
      acceleratorOtherInfo: {},
      newProduct: {},
      uploadPercentage: 0,
      mehvarBusy: true,
      isUploaded: false,
      file: [],
      myFile: new Object({
        uploadPercentage: 0,
      }),
      changeLogo: false,
      iran: [],
      busy: false,
      isBusy: false,

      productBusy: true,
      isLoaded: true,
      loaded: false,
      has_number: false,
      has_lowercase: false,
      has_uppercase: false,
      type: "",
      seeMoreModal: false,
      seeMoreType: "",
      categories: [],
      productFields: [
        { key: "index", label: "ترتیب" },
        { key: "title", label: "محصول" },
        { key: "operation", label: "عملیات" },
      ],
      productItems: [],
      productPerPage: 10,
      productCurrentPage: 1,
      productTotalRows: 1,
      newProduct: "",
      companyId: "",
      acceleratorId: "",
      showImage: false,
      deleteImage: false,
      editImage: false,
      addImage: false,
      selected: {},
      uploading: false,
      fileName: "",
      tabNumber: 0,
      vLoading: false,
      test: [],
      title: "",
      uploading: false,
      addLogoImage: false,
      model: 0,
      newMehvar: "",
      newMehvarMozou: "",
      newMehvarUniversity: "",
      newMehvarNumber: "",
      newMehvarDate: "",
      mehvars: [],
      mehvarFields: [
        { key: "index", label: "#" },
        { key: "name", label: "محور" },
        { key: "operation", label: "عملیات" },
      ],
      requests: {},
      planFields: [
        { key: "index", label: "#" },
        { key: "faSubject", label: "عنوان فارسی" },
        { key: "requestsCode", label: "کد طرح" },
        { key: "status", label: "وضعیت" },
        { key: "lastUpdate", label: "آخرین بروزرسانی" },
        { key: "operation", label: "عملیات" },
      ],
      acceleratorPassword: "",
      acceleratorRepeatPassword: "",
      requestFilter: "",
      requestFilter2: "",
      requestBusy: true,
      projectFilter: "",
      phdFilter: "",
      eliteFilter: "",
      articleFilter: "",
      postDocFilter: "",
      meetingFilter: "",
      opportuneFilter: "",
      masterFilter: "",
      selectedMehvar: {},
      removeMehvarDialog: false,
    };
  },
  methods: {
    openSeeMoreModal(type) {
      this.seeMoreType = type;
      this.seeMoreModal = true;
    },
    openRemoveMehvarDialog(item) {
      this.selectedMehvar = item;
      this.removeMehvarDialog = true;
    },
    checkWebsite() {
      if (
        this.acceleratorInfo.website.indexOf("http://") == 0 ||
        this.acceleratorInfo.website.indexOf("https://") == 0
      ) {
        return this.acceleratorInfo.website;
      } else {
        return "//" + this.acceleratorInfo.website;
      }
    },
    checkUrl(url) {
      if (this.editInfo.website) {
        if (validator.isURL(url)) {
          return true;
        } else {
          return false;
        }
      } else return true;
    },
    validateEmail(email) {
      //NOTE checking validation of email
      if (email) {
        var re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase()) ? true : false;
      } else return true;
    },
    dragover(event) {
      event.preventDefault();
      // Add some visual fluff to show the user can drop its files
      // if (!event.currentTarget.classList.contains("bg-green-300")) {
      //   event.currentTarget.classList.remove("bg-gray-100");
      //   event.currentTarget.classList.add("bg-green-300");
      // }
    },

    dragleave(event) {
      // Clean up
      // event.currentTarget.classList.add("bg-gray-100");
      // event.currentTarget.classList.remove("bg-green-300");
    },
    drop(event) {
      event.preventDefault();
      this.file = event.dataTransfer.files;
      if (Array.from(this.file).length) {
        if (this.addLogoImage) {
          if (Array.from(this.file).length > 1) {
            this.toast(
              " در این بخش شما مجاز به آپلود بیش از یک عکس نمی‌باشید.",
              "error"
            );
            return;
          }
        }
        Array.from(this.file).forEach((file) => {
          this.addLogoImage ? this.myUpload(file) : this.uploadImage(file);
        });
      }
      // Clean up
      // event.currentTarget.classList.add("bg-gray-100");
      // event.currentTarget.classList.remove("bg-green-300");
    },
    openAdd3() {
      // NOTE (m-openAdd3) to show loading
      this.$refs["add3"].show();
    },
    deleteImg() {
      this.busy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/accelerator/removeGallery",
          {
            acceleratorId: this.$route.params.id,
            fileId: this.selected.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.busy = false;
          this.toast(res.data, "success");
          this.deleteImage = false;
          this.update();
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    editImg() {
      this.busy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/accelerator/editGallery",
          {
            acceleratorId: this.$route.params.id,
            fileId: this.selected.id,
            title: this.selected.title,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.busy = false;

          this.editImage = false;
          this.toast(res.data, "success");
          this.update();
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    myUpload(file) {
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast(
          "حجم فایل " + file.name + " نباید از 5 مگابایت بیشتر باشد",
          "error"
        );
        return;
      } else if (file.type != "image/jpeg" && file.type != "image/png") {
        this.toast("فرمت فایل مورد نظر مجاز نمی‌باشد. ", "error");
        return;
      } else {
        // NOTE (m-myUpload) to upload files
        this.acceleratorId = this.$route.params.id;
        this.uploading = true;
        this.changeProfile = false;
        this.myFile.showProgress = true;
        this.myFile.variant = "info";
        this.myFile.uploadPercentage = 0;
        this.myFile.isUploaded = false;
        this.myFile.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(
            this.baseUrl +
              "/setad/admin/accelerator/avatar?acceleratorId=" +
              this.acceleratorId,
            formData,
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
              onUploadProgress: ((progressEvent) => {
                this.myFile.uploadPercentage =
                  Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  ) - 1;
              }).bind(this),
            }
          )
          .then((d) => {
            if (d.status == 200) {
              this.myFile.isUploaded = true;
              this.myFile.uploadPercentage = 100;
              this.myFile.striped = false;
              this.myFile.variant = "success";
              this.myFile.uploadButDisable = false;
              this.addLogoImage = false;
              this.update();
              this.acceleratorInfo.avatar = d.data;
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
      }
    },
    uploadImage(file) {
      // NOTE (m-myUpload) to upload files
      let sizeMB = file.size / 1024 / 1024;
      if (sizeMB > 5) {
        this.toast(
          "حجم فایل " + file.name + " نباید از 5 مگابایت بیشتر باشد",
          "error"
        );
        return;
      } else if (file.type != "image/jpeg" && file.type != "image/png") {
        this.toast("فرمت فایل مورد نظر مجاز نمی‌باشد. ", "error");
        return;
      } else {
        this.acceleratorId = this.$route.params.id;
        this.uploading = true;
        this.changeProfile = false;
        this.myFile.showProgress = true;
        this.myFile.variant = "info";
        this.myFile.uploadPercentage = 0;
        this.myFile.isUploaded = false;
        this.myFile.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(
            this.baseUrl +
              "/setad/admin/accelerator/addGallery?acceleratorId=" +
              this.acceleratorId +
              "&&title=" +
              this.title,
            formData,
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
              onUploadProgress: ((progressEvent) => {
                this.myFile.uploadPercentage =
                  Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  ) - 1;
              }).bind(this),
            }
          )
          .then((d) => {
            if (d.status == 200) {
              this.myFile.isUploaded = true;
              this.myFile.uploadPercentage = 100;
              this.myFile.striped = false;
              this.myFile.variant = "success";
              this.myFile.uploadButDisable = false;
              this.toast("تصویر با موفقیت افزوده شد.", "success");

              setTimeout(() => {
                this.addImage = false;
                this.update();
              }, 200);
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
      }
    },

    getStatesAndCities() {
      this.$http
        .get(this.baseUrl + "/setad/options/states/list", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        })
        .then((res) => {
          this.iran = res.data;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    getacceleratorInfo() {
      this.vLoading = true;
      this.loaded = false;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/accelerator/getInfo",
          {
            acceleratorId: this.$route.params.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.vLoading = false;
          if (window.screen.width < 850) {
            this.type = "mobile";
          } else {
            if (document.body.clientWidth < 850) {
              this.type = "mobile";
            } else {
              this.type = "desktop";
            }
          }

          this.acceleratorInfo = res.data;
          this.requests = res.data.requests;

          this.editInfo = JSON.parse(JSON.stringify(this.acceleratorInfo));

          this.getStatesAndCities();
          this.getCats();
          this.getMehvars();
          this.loaded = true;
          this.mehvarBusy = false;
          this.requestBusy = false;
        })
        .catch((err) => {
          this.vLoading = false;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    update() {
      this.$http
        .post(
          this.baseUrl + "/setad/admin/accelerator/getInfo",
          {
            acceleratorId: this.$route.params.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          if (window.screen.width < 850) {
            this.type = "mobile";
          } else {
            if (document.body.clientWidth < 850) {
              this.type = "mobile";
            } else {
              this.type = "desktop";
            }
          }

          this.acceleratorInfo = res.data;
          this.requests = res.data.requests;
          this.editInfo = JSON.parse(JSON.stringify(this.acceleratorInfo));
          this.loaded = true;
          this.mehvarBusy = false;
          this.requestBusy = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    submit() {
      this.isBusy = true;

      this.$http
        .post(
          this.baseUrl + "/setad/admin/accelerator/edit",
          {
            acceleratorId: this.$route.params.id,
            name: this.editInfo.name,
            tel: this.editInfo.tel,
            mobile: this.editInfo.mobile,
            email: this.editInfo.email,
            website: this.editInfo.website,
            registrationNumber: this.editInfo.registrationNumber,
            nationalId: this.editInfo.nationalId,
            economicCode: this.editInfo.economicCode,
            stateId: this.editInfo.stateId ? this.editInfo.stateId : null,
            cityId: this.editInfo.cityId ? this.editInfo.cityId : null,
            address: this.editInfo.address,
            website: this.editInfo.website,
            products: this.editInfo.products,
            catId: this.editInfo.catId ? this.editInfo.catId : "",
            ceoName: this.editInfo.ceoName,
            description: this.editInfo.description,
            isTrusted: this.editInfo.isTrusted,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast(res.data, "success");
          this.update();
          this.tabNumber = 0;
          document.querySelector("html").scroll({
            top: 0,
            left: 0,
            behavior: "smooth",
          });
          this.isBusy = false;
        })
        .catch((err) => {
          this.isBusy = false;
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            this.$router.push({
              path: "/login",
              query: { return: window.location.pathname },
            });
          }
        });
    },
    addProduct() {
      let duplicates = [];
      if (this.editInfo.products.length) {
        this.editInfo.products.forEach((x) => {
          if (this.newProduct == x.title) {
            duplicates.push(this.newProduct);
          }
        });
      }
      if (duplicates.length) {
        this.toast("امکان ثبت محصولی تکراری وجود ندارد", "error");
      } else {
        this.editInfo.products.push({
          title: this.newProduct,
        });
        this.productTotalRows = this.editInfo.products.length;
        this.newProduct = "";
      }
    },
    getCats() {
      this.$http
        .post(
          this.baseUrl + "/setad/options/cats/list",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.categories = [];
          this.categories.push(
            ...res.data.map((x) => {
              return {
                code: x.id,
                label: x.name,
              };
            })
          );
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    getMehvars() {
      this.$http
        .post(
          this.baseUrl + "/setad/options/uniMehvars",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.mehvars = res.data;
          //this.mehvars.push(
          //  ...res.data.map((x) => {
          //    return {
          //      code: x.id,
          //      label: x.text,
          //    };
          //  })
          //);
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    openDeleteDialog(item) {
      this.selected = item;
      this.deleteImage = true;
    },
    openEditDialog(item) {
      this.selected = JSON.parse(JSON.stringify(item));
      this.editImage = true;
    },

    openAddImageModal() {
      this.title = "";
      this.uploading = false;
      this.addImage = true;
    },
    showBig(item) {
      this.selected = item;
      this.showImage = true;
    },
    addMehvar() {
      this.$bvModal.show("loading");
      this.isLoaded = false;
      // NOTE (m-addMehvar) to add new subject
      this.$http
        .post(
          this.baseUrl + "/setad/admin/accelerator/addMehvar",
          {
            mehvarId: this.newMehvar,
            acceleratorId: this.$route.params.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast(res.data, "success");
          this.newMehvar = "";
          this.$refs["add3"].hide();
          this.$bvModal.hide("loading");

          setTimeout(() => {
            this.getacceleratorInfo();
          }, 200);
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    removeMehvar() {
      this.$bvModal.show("loading");
      this.isLoaded = false;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/accelerator/removeMehvar",
          {
            mehvarId: this.selectedMehvar.id,
            acceleratorId: this.$route.params.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast(res.data, "success");
          this.$bvModal.hide("loading");
          this.removeMehvarDialog = false;
          setTimeout(() => {
            this.getacceleratorInfo();
          }, 200);
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    passStrength() {
      this.has_number = /\d/.test(this.acceleratorPassword);
      this.has_lowercase = /[a-z]/.test(this.acceleratorPassword);
      this.has_uppercase = /[A-Z]/.test(this.acceleratorPassword);
    },
    changePassword() {
      // NOTE (m-changePassword) to change the password
      if (
        this.has_number &&
        this.has_lowercase &&
        this.has_uppercase &&
        this.acceleratorPassword.length > 7
      ) {
        this.isBusy = true;
        this.$bvModal.show("loading");
        this.$http
          .post(
            this.baseUrl + "/setad/admin/accelerator/changePassword",
            {
              acceleratorId: this.$route.params.id,
              password: md5(this.acceleratorPassword),
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.isBusy = false;
            this.toast(res.data, "success");
            this.$bvModal.hide("loading");
            this.acceleratorPassword = "";
            this.acceleratorRepeatPassword = "";
            this.has_uppercase = false;
            this.has_lowercase = false;
            this.has_number = false;
          })
          .catch((err) => {
            this.isBusy = false;
            console.log(err);
            this.toast(err.response.data, "error");
            this.$bvModal.hide("loading");
          });
      } else {
        this.toast(
          "لطفا جهت حفظ امنیت اطلاعات خود موارد خواسته شده را در رمز خود اعمال کنید",
          "error"
        );
        this.$bvModal.hide("loading");
      }
    },
  },
  computed: {
    computedUsername() {
      if (!/^[a-zA-Z]+$/.test(this.editInfo.username)) {
        if (/^[0-9]+$/.test(this.editInfo.username)) {
          return false;
        } else {
          return true;
        }
      } else return true;
    },
    showProductMoreBtn() {
      let temp;
      if (this.acceleratorInfo.products) {
        temp = this.acceleratorInfo.products.filter((x) => x.title.length > 60);
        if (temp.length) {
          return true;
        } else {
          return false;
        }
      }
    },
    checkPassword() {
      // NOTE (c-checkPass) to check that the password is not duplicate
      return this.acceleratorPassword == this.acceleratorRepeatPassword
        ? null
        : false;
    },
  },
  mounted() {
    this.getacceleratorInfo();
  },
};
</script>
<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style lang="scss">
.company {
  .common-card {
    position: relative !important;
    .seeMore-btn {
      position: absolute !important;
      bottom: 15px !important;
      left: 15px !important;
    }
  }
  .color {
    background-color: #0c4961;
    color: white;
  }
  .image-box {
    height: 100px;
    width: 90%;
    margin: auto;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .uploadPercentage {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    background-color: rgba(19, 18, 18, 0.726);
    text-align: center;
    z-index: 70;
    padding: 10px;
    span {
      color: whitesmoke;
      margin: auto;
      font-size: 0.9rem;
    }
  }
  .company-view {
    background-color: #f2f2f5;
  }
  .view-imageBox {
    width: 165px;
    height: 165px;
    margin-bottom: 10px;
    img {
      width: 100%;
      height: 100%;
      border-radius: 3px;
    }
  }
  @media only screen and (min-width: 600px) {
    .description-box {
      width: calc(100% - 170px);
    }
  }
  .edit-imageBox {
    width: 15vw;
    height: 15vw;
    margin-bottom: 10px;
    img {
      width: 100%;
      height: 100%;
      border-radius: 3px;
    }
  }
  @media only screen and (max-width: 960px) {
    .edit-imageBox {
      width: 30vw;
      height: 30vw;
    }
  }
  @media only screen and (max-width: 600px) {
    .edit-imageBox {
      width: 40vw;
      height: 40vw;
    }
  }
  .gallery-imageBox {
    margin: 20px auto;
    height: 210px;
    cursor: pointer;
    position: relative !important;
    border-radius: 3px;
    .image-title {
      width: 100%;
      text-align: right;
      color: #fff;
      padding: 13px;
      position: absolute;
      bottom: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 91;
      path {
        stroke: #fff;
      }
    }
    .v-image {
      width: 100%;
      height: 100%;
    }
    .hover-box {
      position: absolute;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 90;
      width: 100%;
      height: 100%;
      display: none;
      color: #fff !important;
      path,
      circle {
        stroke: #fff !important;
      }
      div {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        padding: 20px;
        background-color: rgba(0, 0, 0, 0.6);
        border-radius: 7px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }
    &:hover {
      .hover-box {
        display: block;
      }
    }
  }
  .img-col {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .gallery-img {
    width: 150px;
    height: 95px;
    border-radius: 5px;
  }

  /* pass validation style */
  .pass {
    font-size: 13px;
  }
  .pass--passed {
    color: #717b85;
  }
  .frmIcon {
    color: #eb0029;
  }
  .pass--passed .frmIcon {
    color: #0fa140;
  }
  .required {
    color: red;
  }

  .done {
    color: green;
  }
}
.modal-card {
  .file-icon {
    path {
      stroke: #068d9d;
    }
  }
  .upload-box {
    padding: 20px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='9' ry='9' stroke='rgb(6, 141, 157)' stroke-width='2' stroke-dasharray='5' stroke-dashoffset='5' stroke-linecap='butt'/%3e%3c/svg%3e");
  }
  .textField-box2 {
    .v-text-field__details {
      display: none;
    }
    .v-text-field .v-input__slot,
    .v-text-field fieldset {
      border-radius: 6px !important;
      border-color: #068d9d !important;
    }
    .v-input__slot {
      min-height: 48px !important;
      margin-bottom: 25px;
      input {
        color: #656a81 !important;
      }
      .v-text-field__suffix {
        color: #656a81 !important;
      }
    }
  }
}
.delete-modalCard {
  img {
    width: 200px;
    height: 100%;
    border-radius: 3px;
  }
}
.show-modalCard {
  border-radius: 10px !important;
  img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
}
.profile-modalCard {
  border-radius: 10px !important;
  overflow: hidden !important;
  .image-box {
    height: 60vh;
    width: 75vh;
    max-width: 100%;
    max-height: 500px;
    min-width: 300px;
    margin: auto;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    img {
      width: 100%;
      height: 100%;
    }
  }
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(61, 60, 60, 0.781);
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: rgba(46, 45, 45, 0.945);
    border-radius: 6px;
  }

  .cancel-btn {
    background-color: #6399e2 !important;
    color: #fff !important;
    box-shadow: none !important;
    width: 110px !important;
  }
  .cancel-btn {
    background-color: rgb(182, 39, 39) !important;
    color: #fff;
    box-shadow: none !important;
    width: 110px !important;
  }
  .change-btn {
    background-color: #6399e2 !important;
    color: #fff !important;
    box-shadow: none !important;
    width: 110px !important;
  }
}

.file-icon {
  path {
    stroke: #068d9d;
  }
}
.slider-img .v-image {
  border-radius: 5px !important;
}

/* pass validation style */
.pass {
  font-size: 13px;
}
.pass--passed {
  color: #717b85;
}
.frmIcon {
  color: #eb0029;
}
.pass--passed .frmIcon {
  color: #0fa140;
}
.required {
  color: red;
}

.done {
  color: green;
}
</style>
